import React from "react"; 
import { Link } from "react-router-dom";    
import CreatePaymentTermForm from "./CreatePaymentForm";

const CreatePaymentForm = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create Payment Form</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/payment-terms">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Payment Terms</li>
          <li>Create Payment Form</li>
        </ul>
      </div> */}

      <CreatePaymentTermForm /> 
    </> 
  );
};

export default CreatePaymentForm;
